import { svg } from 'lit';
export const swap24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.718 15.979C3.658 14.919 3 13.457 3 11.849C3 8.632 5.632 6 8.849 6L16 6.021" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 8.02148L16 6.02148L14 4.02148" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.282 8.02148C20.342 9.08148 21 10.5435 21 12.1515C21 15.3685 18.368 18.0005 15.151 18.0005L8 17.9795" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 15.9785L8 17.9785L10 19.9785" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
//# sourceMappingURL=swap_24.svg.js.map